<template>
  <div id="Respuesta">
    <hiw-header />
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2>¡Gracias por tu compra, Juan!</h2>
          <hr class="divider-resp" />
          <p class="divider-subtext mt-0">En unos minutos llegará al email y teléfono que registraste, un mensaje de confirmación con los detalles del plan que elegiste.</p>
        </div>
      </div>
      <div class="row my-5">
        <div class="col-12 col-md-3">
          <p class="tus-datos my-0">Tus datos:</p>
        </div>
        <div class="col-12 col-md-4 d-flex align-items-center">
          <img :src="require('@/assets/img/mail-checkout.svg')" style="height: 31px;" alt="Dr click" />
          <p class="ml-3 my-0">juancamiloariza@gmail.com</p>
        </div>
        <div class="col-12 col-md-5 d-flex align-items-center">
          <img :src="require('@/assets/img/iphone.svg')" style="height: 31px;" alt="Dr click" />
          <p class="ml-3 my-0">+57 310 588 8363</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-card no-body class="text-center p-2 container-90">
            <div class="row">
              <div class="col-12 col-md-6">
                <p class="my-0 text-left">Plan Plus</p>
              </div>
              <div class="col-12 col-md-6">
                <p class="my-0 text-right">$113 689 COP</p>
              </div>
            </div>
          </b-card>
        </div>
        <div class="col-12 d-flex my-3 align-items-center">
          <div class="container-90 d-flex">
            <b-icon icon="exclamation-circle" style="width: 18px; height: 18px;"></b-icon>
            <p class="my-0 ml-2">En Línea Pagos (ELP) te hará un microdébito de 300 pesos para validar tu tarjeta que será regresado a tu cuenta en breve.</p>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center my-5">
          <button class="btn-back">
            <p>Volver Dr. Clik</p>
          </button>
        </div>
      </div>
    </div>
    <div class="download-app">
      <h1>
        Descarga el app en tu plataforma preferida
      </h1>
      <div class="row justify-content-center mt-4">
        <div class="inline-flex row-app-store flex-wrap md:justify-center flex-md-nowrap">
          <img alt="Google Play DrClick" src="@/assets/img/Responsive_googleplay.png" width="191" class="mx-2" />
          <img alt="Google Play DrClick" src="@/assets/img/Responsive_appstore.png" width="192" class="mx-2" />
        </div>
      </div>
    </div>
    <global-footer />
  </div>
</template>

<script>
import HiwHeader from '@/components/checkout/Header';
import Footer from '@/components/home/Footer';

export default {
  name: 'Respuesta',
  components: {
    HiwHeader,
    GlobalFooter: Footer,
  },
};
</script>

<style scoped>
.download-app {
  width: 100%;
  height: 452px;
  background: linear-gradient(93.01deg, #37caff 11.88%, #32eebe 198.12%);
  clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 0 0, 50% 20%);
  -webkit-clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 0 0, 50% 20%);
  -moz-clip-path: polygon(100% 0, 100% 50%, 100% 100%, 0% 100%, 0 0, 50% 20%);
  padding-top: 150px;
}

.download-app h1 {
  font-weight: 800;
  font-size: 36px;
  line-height: 60px;

  text-align: center;
  color: #ffffff;
}

.divider-resp {
  background: linear-gradient(93.01deg, #37caff 11.88%, #32eebe 198.12%);
  width: 100%;
  height: 1px;
  margin-bottom: 0;
}
h2 {
  font-family: Avenir !important;
  font-style: normal;
  font-weight: 800;
  font-size: 36px;
  line-height: 60px;
  text-align: center;
}
p.tus-datos {
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 30px;
  text-align: center;
}

.btn-back {
  width: 299px;
  height: 38px;
  border: 2px solid #37cbfe;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-back p {
  font-style: normal;
  font-weight: normal;
  font-size: 25px;
  line-height: 10px;
  text-align: center;
  color: #37cbfd;
  margin: 0;
}
p.divider-subtext {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 30px;
  text-align: center;
}
.container-90 {
  width: 90%;
  margin-right: auto;
  margin-left: auto;
}
</style>
